import { Alert, AlertTitle, Box, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import Capa from '../../Controls/Capa/Capa';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AuthContext } from '../../../Context/AuthContext';
import EscoAutocomplete from '../../Controls/EscoAutocomplete/EscoAutocomplete';
import Rango from '../../Controls/EscoRango/EscoRango';
import { UpdateParam } from '../../../Service/microservicioService';
import dayjs from 'dayjs';
import EscoComboBooleano from '../../Controls/EscoComboBooleano/EscoComboBooleano';
import FrmParamsDataView from './FrmParamsDataView';
import { UpdateFrmParam } from '../../../Service/frmParametros';

function FrmParamsView(props) {

    const { accessToken } = useContext(AuthContext);
    const [detalle, setDetalle] = useState()
    //const [selectedOptions, setSelectedOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hayCambios, setHayCambios] = useState(false);

    useEffect(() => {

        setDetalle({ ...props.dataEdit });

    }, [props.dataEdit]);



    const handleChangeNumerico = (e) => {
        setHayCambios(true);
        const nuevoNumero = e.target.value;
        if (!isNaN(nuevoNumero)) {
            setDetalle({
                ...detalle,
                Valor: e.target.value,
            });
        }
    };

    const onAceptar = (e) => {
        e.preventDefault();

        if (hayCambios === false) {
            props.pInit();
            props.handleClose();
            return
        }

        // Se obtiene los datos del formulario
        //  const formData = new FormData(e.currentTarget);

        const frmUpdateFrmConfigRequest = {
            CodFrmConfig: detalle.CodFrmConfig,
            Valor : detalle.Valor
            }

        UpdateFrmParam({ frmUpdateFrmConfigRequest }, accessToken)
            .then(data => {
                if (data != undefined && data.Message != undefined && data.Message.includes("Error")) {
                    //setMsjTitle(data.Message);
                    //setOpenMsj(true);
                    return;
                } else {
                    props.pInit();
                    props.handleClose();
                }
            }).catch(
                error => {
                    //setMsjTitle(error.toString());
                    //setOpenMsj(true);
                });

    }

    let componenteRenderizado;

    componenteRenderizado = <TextField
        label="Valor Parámetro"
        variant="outlined"
        type="number"
        //inputProps={{ step: 'any' }} // Permite números decimales
        value={detalle?.Valor}
        onChange={handleChangeNumerico}

    />



    return (
        <>
                <Box component={'form'} onSubmit={onAceptar} /*onSubmit={props.onAceptar}*/>
                    <Capa onCancel={props.handleClose} title={"Parámetro"}>
                        <Typography variant="button" sx={{ fontSize: 14, color: 'gray', mb: 1 }}>{detalle?.Descripcion}</Typography>

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                mb: 1,
                                mt: 1
                            }}
                        >
                            {componenteRenderizado}
                        </Box>
                    </Capa>
                </Box>
        </>
    );
}

export default FrmParamsView;
